import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { loader } from 'graphql.macro';
import { useMutation } from 'react-apollo-hooks';
import { useTranslation } from 'react-i18next';

import { ProfileContext } from '@loyalup/core';
import { Button, Select, Form, Modal, useNotifications } from '@loyalup/ui';

import store from 'utils/store';

const DELETE_CLIENTS_MUTATION = loader('../../gql/mutations/DeleteClients.gql');
const SEND_PASS_TO_CLIENT_MUTATION = loader('../../gql/mutations/SendPassToClient.gql');

const ClientGroupActions = ({ className, selection, loading, onActionFinish, history }) => {
  const [t] = useTranslation();
  const {
    permissions: { manageCompanyCampaigns },
  } = useContext(ProfileContext);

  const [sendNotification] = useNotifications();

  const { include, exclude, conds, text } = selection;
  const [deletingClients, setDeletingClients] = useState(false);

  const [partySendAlert, setPartySendAlert] = useState(null);

  const variables = {
    selection: {
      all: include === 'all',
      include: include === 'all' ? [] : include,
      exclude,
      conds,
      text,
    },
  };

  const [deleteClients] = useMutation(DELETE_CLIENTS_MUTATION, { update: () => onActionFinish('delete') });
  const [sendPassToClient] = useMutation(SEND_PASS_TO_CLIENT_MUTATION);

  const handleSendPassResponse = (response, selection) => {
    if (response.error) return sendNotification({ text: response.error, type: 'error' });
    if (response.totalSend < response.totalCount) {
      setPartySendAlert({
        send: response.totalSend,
        count: response.totalCount,
        diff: response.totalCount - response.totalSend,
      });
    }
    sendNotification({
      text: t(selection.include.length === 1 ? 'Карта отправлена клиенту' : 'Карты отправлены клиентам'),
    });
  };

  const sendPass = sendType => {
    sendPassToClient({
      variables: {
        selection: variables.selection,
        sendType,
      },
      update: (_, { data: { sendPassToClients } }) => {
        handleSendPassResponse(sendPassToClients, variables.selection);
      },
    });
  };

  const items = [
    {
      label: t('Отправить карту по е-мейл'),
      onClick: () => {
        sendPass('EMAIL');
      },
    },
    {
      label: t('Отправить карту по СМС'),
      onClick: () => {
        sendPass('SMS');
      },
    },
    manageCompanyCampaigns && {
      label: t('Отправить уведомление'),
      onClick: () => {
        const campaignId = store.save(selection);
        history.push(`/campaigns/new/${campaignId}`);
      },
    },
    { label: t('Удалить'), onClick: () => setDeletingClients(true) },
  ].filter(item => !!item);

  return (
    <div className={className}>
      <Select theme="green" loading={loading} disabled={include.length === 0} label={t('Действия')} items={items} />
      <Modal confirm isOpen={!!partySendAlert} onClose={() => setPartySendAlert(null)}>
        <Form
          onSubmit={() => {
            setPartySendAlert(null);
          }}
        >
          <p>
            {t(
              partySendAlert?.diff === 1
                ? 'Отправлено {{send}} из {{count}}, у {{diff}} клиента не указан e-mail. Выберите фильтр “Без емейла” и отправьте карты по SMS, либо добавьте актуальные e-mail адреса'
                : 'Отправлено {{send}} из {{count}}, у {{diff}} клиентов не указан e-mail. Выберите фильтр “Без емейла” и отправьте карты по SMS, либо добавьте актуальные e-mail адреса',
              partySendAlert,
            )}
          </p>
          <Button type="submit" theme="green" fixedWidth={220} center loading={loading}>
            {t('Ок')}
          </Button>
        </Form>
      </Modal>
      <Modal confirm isOpen={!!deletingClients} onClose={() => setDeletingClients(false)}>
        <Form
          onSubmit={() => {
            setDeletingClients(false);
            deleteClients({ variables });
          }}
        >
          <p>{t('Вы уверены что хотите удалить выбранных клиентов?')}</p>
          <div>
            <Button type="submit" theme="green" center loading={loading}>
              {t('Удалить')}
            </Button>
            <Button theme="black" onClick={() => setDeletingClients(false)}>
              {t('Отмена')}
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

ClientGroupActions.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onActionFinish: PropTypes.func,
  selection: PropTypes.shape({
    conds: PropTypes.array,
    text: PropTypes.string,
    include: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    exclude: PropTypes.array.isRequired,
  }),
};

export default withRouter(ClientGroupActions);
